import { createSlice } from '@reduxjs/toolkit'
// eslint-disable-next-line import/no-cycle
import {
  emailVerify,
  forgotPassword,
  getGuestNotification,
  logOut,
  resetPassword,
  resetPasswordCodeVerify,
  signIn,
  signUp
} from 'store'
import {
  PENDING,
  REJECTED,
  SIGN_IN,
  SUCCEEDED,
  VERIFICATION_TYPES
} from 'utils/constants'

const initialState = {
  accessToken: null,
  user: null,
  pageName: '',
  verifyPageText: '',
  modalTitle: '',
  authPage: '',
  isSignIn: false,
  isAlreadyVerified: false,
  guestNotification: [],
  verificationEmailStandBy: '',
  verificationFor: '',
  tempEmail: '',
  tempPassword: '',
  signInStatus: PENDING | SUCCEEDED | REJECTED,
  signUpStatus: PENDING | SUCCEEDED | REJECTED,
  emailVerifyStatus: PENDING | SUCCEEDED | REJECTED,
  forgotPasswordStatus: PENDING | SUCCEEDED | REJECTED,
  resetPasswordStatus: PENDING | SUCCEEDED | REJECTED,
  resetPasswordCodeVerifyStatus: PENDING | SUCCEEDED | REJECTED,
  logOutStatus: PENDING | SUCCEEDED | REJECTED,
  guestNotificationStatus: PENDING | SUCCEEDED | REJECTED
}

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleChangePage: (state) => {
      state.pageName = ''
    },
    handleModalTitle: (state, action) => {
      state.modalTitle = action.payload
    },
    setAuthPage: (state, action) => {
      state.authPage = action.payload
    },
    setIsSignIn: (state, action) => {
      state.isSignIn = action.payload
    },
    setVerificationEmailStandBy: (state, action) => {
      state.resetPasswordStatus = 0
      state.emailVerifyStatus = 0
      state.verificationEmailStandBy = action.payload.email
      // state.verificationFor = action.payload.for
    },
    setLogInCredentials: (state, action) => {
      state.emailVerifyStatus = 0
      state.tempEmail = action.payload.email
      state.tempPassword = action.payload.password
    }
  },
  extraReducers: {
    // SIGN IN
    [signIn.pending]: (state) => {
      state.signInStatus = PENDING
    },
    [signIn.fulfilled]: (state, action) => {
      state.signInStatus = SUCCEEDED
      state.accessToken = action.payload
    },
    [signIn.rejected]: (state) => {
      state.signInStatus = REJECTED
    },
    // SIGN UP
    [signUp.pending]: (state) => {
      state.signUpStatus = PENDING
    },
    [signUp.fulfilled]: (state, action) => {
      state.signUpStatus = SUCCEEDED

      state.pageName = SIGN_IN
      state.authPage = SIGN_IN
      // state.emailVerifyStatus = 0
      // state.verificationEmailStandBy = action.meta.arg.email
      // state.verificationFor = VERIFICATION_TYPES.Email
    },
    [signUp.rejected]: (state) => {
      state.signUpStatus = REJECTED
    },
    // Email Verify
    [emailVerify.pending]: (state) => {
      state.emailVerifyStatus = PENDING
    },
    [emailVerify.fulfilled]: (state) => {
      state.emailVerifyStatus = SUCCEEDED
    },
    [emailVerify.rejected]: (state) => {
      state.emailVerifyStatus = REJECTED
      state.isAlreadyVerified = true
    },
    // Forgot Password
    [forgotPassword.pending]: (state) => {
      state.forgotPasswordStatus = PENDING
    },
    [forgotPassword.fulfilled]: (state, action) => {
      state.forgotPasswordStatus = SUCCEEDED

      // state.resetPasswordStatus = 0
      // state.resetPasswordCodeVerifyStatus = 0
      // state.verificationEmailStandBy = action.meta.arg.email
      // state.verificationFor = VERIFICATION_TYPES.ForgotPassword
    },
    [forgotPassword.rejected]: (state) => {
      state.forgotPasswordStatus = REJECTED
    },
    // Reset Password
    [resetPassword.pending]: (state) => {
      state.resetPasswordStatus = PENDING
    },
    [resetPassword.fulfilled]: (state) => {
      state.resetPasswordStatus = SUCCEEDED
    },
    [resetPassword.rejected]: (state) => {
      state.resetPasswordStatus = REJECTED
    },
    // Reset Password Code Verify
    [resetPasswordCodeVerify.pending]: (state) => {
      state.resetPasswordCodeVerifyStatus = PENDING
    },
    [resetPasswordCodeVerify.fulfilled]: (state, action) => {
      state.resetPasswordCodeVerifyStatus = SUCCEEDED

      state.verificationEmailStandBy = action.meta.arg.email
      // state.verificationFor = VERIFICATION_TYPES.ResetPassword
    },
    [resetPasswordCodeVerify.rejected]: (state) => {
      state.resetPasswordCodeVerifyStatus = REJECTED
    },
    // Log Out
    [logOut.pending]: (state) => {
      state.logOutStatus = PENDING
    },
    [logOut.fulfilled]: (state) => {
      state.logOutStatus = SUCCEEDED
    },
    [logOut.rejected]: (state) => {
      state.logOutStatus = REJECTED
    },
    // Guest Notification
    [getGuestNotification.pending]: (state) => {
      state.guestNotificationStatus = PENDING
    },
    [getGuestNotification.fulfilled]: (state, action) => {
      state.guestNotificationStatus = SUCCEEDED
      state.guestNotification = action.payload
    },
    [getGuestNotification.rejected]: (state) => {
      state.guestNotificationStatus = REJECTED
    }
  }
})

export const {
  handleChangePage,
  handleModalTitle,
  setAuthPage,
  setIsSignIn,
  setLogInCredentials,
  setVerificationEmailStandBy
} = auth.actions

export default auth.reducer
